import {Typography} from '@mui/material';
import './DeleteQuestionModal.scss';
import ArrModal from '../../../../common/arr-modal/ArrModal';
import {t} from 'i18next';
import React, {useId} from 'react';

interface DeleteQuestionModalProps {
  questionId: string | null;
  open: boolean;
  onClose: () => void;
  onConfirm: (questionId: string) => Promise<void> | void;
}

const DeleteQuestionModal = ({
  questionId,
  open,
  onClose,
  onConfirm,
}: DeleteQuestionModalProps) => {
  const cancelDescId = useId();
  const removeDescId = useId();

  const handleConfirm = async () => {
    if (!questionId) return;
    await onConfirm(questionId);
    onClose();
  };

  if (!questionId) return null;

  return (
    <>
      <ArrModal
        className="deleteQuestion"
        headerTitleClassName="deleteQuestion__header"
        headerTitle={t('ai.investigate.deleteQuestion.headerTitle')}
        showModal={open}
        onClose={onClose}
        title={t('ai.investigate.deleteQuestion.title')}
        aria-label="delete-ai-investigate-question-modal"
        dataTestId="arr-ipRestriction-delete-modal"
        buttons={[
          {
            id: t('ai.investigate.deleteQuestion.cancel'),
            label: t('ai.investigate.deleteQuestion.cancel'),
            onClick: onClose,
            variant: 'secondary',
            dataTestId: 'ipd-modal-no',
            ariaDescribedBy: cancelDescId,
          },
          {
            id: t('ai.investigate.deleteQuestion.confirm'),
            label: t('ai.investigate.deleteQuestion.confirm'),
            onClick: handleConfirm,
            variant: 'primary',
            dataTestId: 'ipd-modal-yes',
            ariaDescribedBy: removeDescId,
          },
        ]}
      >
        <Typography
          className="deleteQuestion__description"
          data-testid="delete-question-modal-description"
        >
          {t('ai.investigate.deleteQuestion.description')}
        </Typography>

        <Typography
          id={cancelDescId}
          className="sr-only"
          data-testid="delete-question-modal-cancel-hint"
        >
          {t('ai.investigate.deleteModalContent.cancelHint')}
        </Typography>

        <Typography
          id={removeDescId}
          className="sr-only"
          data-testid="delete-question-modal-remove-hint"
        >
          {t('ai.investigate.deleteModalContent.removeHint')}
        </Typography>
      </ArrModal>
    </>
  );
};

export default DeleteQuestionModal;
